import { IServerResponse } from "app/interface";

export interface ContractChangeRequestState {
    requestList: Array<any> | null;
    requestByFieldList: Array<any> | null;
    requestById: any;
    addRequestResponse: IServerResponse;
    updateRequestResponse: IServerResponse;
    deleteRequestResponse: IServerResponse;
    approveRejectRequestResponse: IServerResponse;
}

export const initialState: ContractChangeRequestState = {
    requestList: null,
    requestByFieldList: null,
    requestById: null,
    addRequestResponse: null,
    updateRequestResponse: null,
    deleteRequestResponse: null,
    approveRejectRequestResponse: null
}
